import type { BrandModule } from 'common/types/brandModule';

export type BrandKey = '@arg' | '@danfloss' | '@rigging';

export interface BrandRegistryEntry {
  load: () => Promise<{ default: BrandModule }>;
  freshSessionOnLoad?: boolean;
}

export const BRANDS: Record<BrandKey, BrandRegistryEntry> = {
  '@arg': {
    load: () => import(/* webpackChunkName: "brand-arg" */ '@arg/brand'),
  },
  '@danfloss': {
    load: () => import(/* webpackChunkName: "brand-danfloss" */ '@danfloss/brand'),
    freshSessionOnLoad: true,
  },
  '@rigging': {
    load: () => import(/* webpackChunkName: "brand-rigging" */ '@rigging/brand'),
    freshSessionOnLoad: true,
  },
};

export const PROJECT_IDS: Record<string, BrandKey> = {
  '9ca4abcc-cf95-5132-9557-7f5743bbd56b': '@arg',
  '27b730bc-31b6-5f80-b14f-d75f30ee5e3f': '@danfloss',
  '9e1660f4-433c-587e-aace-5f55eac407b8': '@rigging',
};

export const isBrandKey = (value: string): value is BrandKey => Object.prototype.hasOwnProperty.call(BRANDS, value);

export type BrandResolution =
  | { ok: true, key: BrandKey }
  | { ok: false, reason: string };

export const resolveBrandKey = (projectId: unknown, fallbackKey?: string): BrandResolution => {
  if (typeof projectId === 'string' && projectId.trim() !== '') {
    const key = PROJECT_IDS[projectId.trim().toLowerCase()];
    if (key) {
      return { ok: true, key };
    }
    return { ok: false, reason: `Unknown i18n.variables.project "${projectId}"` };
  }
  if (fallbackKey) {
    if (isBrandKey(fallbackKey)) {
      return { ok: true, key: fallbackKey };
    }
    return { ok: false, reason: `Unknown REACT_APP_DEFAULT_PROJECT "${fallbackKey}"` };
  }
  return { ok: false, reason: 'i18n.variables.project is not set for this rule set' };
};
